"use strict";

import { initHome } from './pages/index.js';
import { initWhenWhere } from './pages/when-where.js';
import { initweddingSquad } from './pages/wedding-squad.js';
import { initweddingKitty } from './pages/wedding-kitty.js';
import { initGallery } from './pages/gallery.js';
import { initPlaylist } from './pages/playlist.js';
import { initAdmin } from './pages/admin.js';
import feather from 'feather-icons';

function scrollToContent(anchor) {
    const theAnchor = anchor || window.location.hash;
    if (theAnchor) {
        const targetElement = document.querySelector(theAnchor);
        if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth' });
        }
        history.pushState(null, null, window.location.pathname);
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const page = window.location.pathname.split('/').pop().replace('.html', '');
    const anchor = window.location.hash
    if (page === 'index' || page === '') {
        initHome();
    } else if (page === 'when-where') {
        initWhenWhere();
    } else if (page === 'wedding-squad') {
        initweddingSquad();
        scrollToContent(anchor);
    }
    else if (page === 'wedding-kitty') {
        initweddingKitty();
        scrollToContent(anchor);
    }
    else if (page === 'gallery') {
        initGallery();
        scrollToContent(anchor);
    }
    else if (page === 'playlist') {
        initPlaylist();
        scrollToContent(anchor);
    }
    else if (page === 'admin') {
        initAdmin();
        scrollToContent(anchor);
    }
    console.log(`Page actuelle ${page}`);
    feather.replace();
});
